import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { QCProvider, useQC } from './QCContext';
import { QCEmployeeDashboard } from './QCEmployeeDashboard';
import { QCSupervisorDashboard } from './QCSupervisorDashboard';
import { QCBrowseJobs } from './QCBrowseJobs';
import { QCMyOffers } from './QCMyOffers';
import { QCReports } from './QCReports';
import { QCAdminSettings } from './QCAdminSettings';
import { QCSubscription } from './QCSubscription';
import { QCStaffingRequests } from './QCStaffingRequests';
import { QCSSOStartPage } from './QCSSOStartPage';

// Wrapper that selects dashboard based on role
const QCDashboard = () => {
  const { user, loading } = useQC();
  
  if (loading) {
    return (
      <div className="flex items-center justify-center h-96">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto"></div>
          <p className="mt-4 text-muted-foreground">Loading...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Route based on role
  if (user.role === 'admin' || user.role === 'supervisor') {
    return <QCSupervisorDashboard />;
  }
  
  return <QCEmployeeDashboard />;
};

// Main Quick Canvass Module Component
export const QuickCanvassModule = () => {
  return (
    <QCProvider>
      <div className="max-w-7xl mx-auto p-4 md:p-8">
        <Routes>
          <Route path="/" element={<QCDashboard />} />
          <Route path="/sso/start" element={<QCSSOStartPage />} />
          <Route path="/employee" element={<QCEmployeeDashboard />} />
          <Route path="/supervisor" element={<QCSupervisorDashboard />} />
          <Route path="/browse-jobs" element={<QCBrowseJobs />} />
          <Route path="/my-offers" element={<QCMyOffers />} />
          <Route path="/reports" element={<QCReports />} />
          <Route path="/settings" element={<QCAdminSettings />} />
          <Route path="/subscription" element={<QCSubscription />} />
          <Route path="/staffing-requests" element={<QCStaffingRequests />} />
          <Route path="*" element={<QCDashboard />} />
        </Routes>
      </div>
    </QCProvider>
  );
};

export default QuickCanvassModule;
